<template>
  <div>
    <h6
      v-if="profileId == 0"
      class="heading-small text-muted mb-4 text-truncate"
    >
      Add New Company {{ inputName ? " - " + this.inputName : "" }}
    </h6>
    <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">
      View Company - {{ this.inputName }}
    </h6>
    <h6 v-else class="heading-small text-muted mb-4 text-truncate">
      Edit Company - {{ this.inputName }}
    </h6>

    <base-alert v-if="errors.length" type="danger">
      <b>You have the following error(s):</b>
      <li v-for="error in errors" :key="error">{{ error }}</li>
    </base-alert>

    <b-tabs
      v-show="profileId != 0 && this.$attrs.viewMode == true"
      content-class="mt-3"
    >
      <b-tab title="Details" active v-on:click="openDetails"></b-tab>
      <b-tab title="History" v-on:click="openHistory">
        <b><label>Created By: </label></b>
        {{ inputCreatedBy || "System" }} | {{ inputCreatedAt | dateFilter }}
        <br />
        <b><label>Updated By:</label></b>
        {{ inputUpdatedBy || "System" }} | {{ inputUpdatedAt | dateFilter }}
      </b-tab>
    </b-tabs>

    <form id="form-proper" v-show="showDetails">
      <!-- {{bagger}} -->
      <div v-if="customFormMode == 1">
        <base-input
          alternative=""
          label="Internal Id"
          placeholder=""
          v-model="inputInternalId"
          input-classes="form-control"
          required
        />
        <base-input
          alternative=""
          label="Company Code"
          placeholder=""
          v-model="inputCode"
          input-classes="form-control"
          required
        />
        <base-input
          alternative=""
          label="Name"
          placeholder=""
          v-model="inputName"
          input-classes="form-control"
          required
        />
        <base-input alternative="" label="Address *" placeholder="">
          <textarea
            v-model="inputAddress"
            rows="4"
            class="form-control"
            required
            style="resize:none;"
          />
        </base-input>
        <base-input
          alternative=""
          label="Contact Person"
          placeholder=""
          v-model="inputContactPerson"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Position"
          placeholder=""
          v-model="inputContactPosition"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Telephone Number"
          placeholder=""
          v-model="inputTelephone"
          input-classes="form-control"
        />
        <base-input
          alternative=""
          label="Fax Number"
          placeholder=""
          v-model="inputFax"
          input-classes="form-control"
        />
        <base-input alternative="" label="Remark">
          <textarea rows="4" class="form-control" v-model="inputRemark" />
        </base-input>
        <base-input
          alternative=""
          label="TIN Number"
          placeholder=""
          v-model="inputTin"
          input-classes="form-control"
          required
        />
        <base-input
          alternative=""
          label="CAS Permit Number"
          placeholder=""
          v-model="inputCasPermitNumber"
          input-classes="form-control"
          required
        />
        <base-input
          alternative=""
          label="Acknowledgement receipt Date Issue"
          placeholder="MMMM D, YYYY"
          v-model="inputDateIssue"
          input-classes="form-control"
          required
        />
        <base-input
          alternative=""
          label="Serial Number Range"
          placeholder=""
          v-model="inputSerialNumberRange"
          input-classes="form-control"
          required
        />
        <base-input label="B2b Customer">
          <div class="form-group row">
            <div class="col-sm-6">
              <input type="text" class="form-control" v-model="b2bCustomerName" disabled>
            </div>
            <div class="col-sm-6">
              <autocomplete
                ref="b2bCustomerAutocomplete"
                placeholder="Search B2b Customer"
                :source="b2bCustomerEndpoint"
                input-class="form-control"
                results-property="data"
                :results-display="formattedDisplay"
                :request-headers="authHeaders"
                @selected="getB2bCustomer">
              </autocomplete>
            </div>
          </div>
        </base-input>
        <base-input label="Supplier">
          <div class="form-group row">
            <div class="col-sm-6">
              <input type="text" class="form-control" v-model="supplierName" disabled>
            </div>
            <div class="col-sm-6">
              <autocomplete
                ref="supplierAutocomplete"
                placeholder="Search Supplier"
                :source="supplierEndpoint"
                input-class="form-control"
                results-property="data"
                :results-display="formattedDisplay"
                :request-headers="authHeaders"
                @selected="getSupplier">
              </autocomplete>
            </div>
          </div>
        </base-input>
        <base-input label="Warehouse Online Site">
        <div class="form-group row">
            <div class="col-sm-6">
              <input type="text" class="form-control" v-model="whsSiteName" disabled>
            </div>
            <div class="col-sm-6">
              <autocomplete
                ref="b2bCustomerAutocomplete"
                placeholder="Search Whs Site"
                :source="whsSiteEndpoint"
                input-class="form-control"
                results-property="data"
                :results-display="formattedDisplay"
                :request-headers="authHeaders"
                @selected="getWhsSite">
              </autocomplete>
            </div>
        </div>

        </base-input>
        <base-input label="Warehouse Offline Site">
        <div class="form-group row">
            <div class="col-sm-6">
              <input type="text" class="form-control" v-model="whsOfflineSiteName" disabled>
            </div>
            <div class="col-sm-6">
              <autocomplete
                ref="b2bCustomerAutocomplete"
                placeholder="Search Whs Site"
                :source="whsSiteEndpoint"
                input-class="form-control"
                results-property="data"
                :results-display="formattedDisplay"
                :request-headers="authHeaders"
                @selected="getWhsOfflineSite">
              </autocomplete>
            </div>
        </div>

        </base-input>
      </div>
      <div v-if="customFormMode == 2">
        <!-- Override -->
        <dynamic-form
          :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
          :formSettings="company"
          @valueUpdated="updateSettings"
          :key="dynamicFormKey"
        />
      </div>
      <div v-if="customFormMode == 3">
        <!-- Append -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Basic" key="1">
            <base-input
              alternative=""
              label="Internal Id"
              placeholder=""
              v-model="inputInternalId"
              input-classes="form-control"
              required
            />
            <base-input
              alternative=""
              label="Company Code"
              placeholder=""
              v-model="inputCode"
              input-classes="form-control"
              required
            />
            <base-input
              alternative=""
              label="Name"
              placeholder=""
              v-model="inputName"
              input-classes="form-control"
              required
            />
            <base-input
              alternative=""
              label="Address *"
              placeholder=""
              v-model="inputAddress"
              input-classes="form-control"
              required
            />
            <base-input
              alternative=""
              label="Contact Person"
              placeholder=""
              v-model="inputContactPerson"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Position"
              placeholder=""
              v-model="inputContactPosition"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Telephone Number"
              placeholder=""
              v-model="inputTelephone"
              input-classes="form-control"
            />
            <base-input
              alternative=""
              label="Fax Number"
              placeholder=""
              v-model="inputFax"
              input-classes="form-control"
            />
            <base-input alternative="" label="Remark">
              <textarea rows="4" class="form-control" v-model="inputRemark" />
            </base-input>
            <base-input
              alternative=""
              label="TIN Number"
              placeholder=""
              v-model="inputTin"
              input-classes="form-control"
              required
            />
            <base-input label="B2b Customer">
              <div class="form-group row">
                <div class="col-sm-6">
                  <input type="text" class="form-control" v-model="b2bCustomerName" disabled>
                </div>
                <div class="col-sm-6">
                  <autocomplete
                    ref="b2bCustomerAutocomplete"
                    placeholder="Search B2b Customer"
                    :source="b2bCustomerEndpoint"
                    input-class="form-control"
                    results-property="data"
                    :results-display="formattedDisplay"
                    :request-headers="authHeaders"
                    @selected="getB2bCustomer">
                  </autocomplete>
                </div>
              </div>
            </base-input>
            <base-input label="Supplier">
              <div class="form-group row">
                <div class="col-sm-6">
                  <input type="text" class="form-control" v-model="supplierName" disabled>
                </div>
                <div class="col-sm-6">
                  <autocomplete
                    ref="supplierAutocomplete"
                    placeholder="Search Supplier"
                    :source="supplierEndpoint"
                    input-class="form-control"
                    results-property="data"
                    :results-display="formattedDisplay"
                    :request-headers="authHeaders"
                    @selected="getSupplier">
                  </autocomplete>
                </div>
              </div>
            </base-input>
          </a-tab-pane>
          <a-tab-pane tab="Custom Fields" key="2" forceRender>
            <dynamic-form
              :convertedJson="{
                mode: customForm.mode,
                groups: customForm.groups_append,
              }"
              :formSettings="company"
              @valueUpdated="updateSettings"
              :key="dynamicFormKey"
              :showErrors="false"
            />
          </a-tab-pane>
        </a-tabs>
      </div>

      <div class="mt-5" v-if="this.$attrs.viewMode != true">
        <!-- Button  -->
        <div
          v-if="serverType == 'ho'"
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
        >
          <button
            v-if="profileId == 0"
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="create"
          >
            Create
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="update"
          >
            Update
          </button>
        </div>
        <div
          v-else
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;"
        >
          <button
            type="button"
            class="btn btn-primary float-right"
            @click.prevent="$emit('closeDrawer', null)"
          >
            Close
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import DynamicForm from "../DynamicForm.vue";
import secureStorage from '../../controllers/secureStorage.js'
import ValidateField from "../../components/validateFormUtils.js";
import { mapState } from "vuex";
import Autocomplete from 'vuejs-auto-complete'
import moment from "moment";
import { decrypt } from "../../utilities.js"
var component_x;
export default {
  components: {
    DynamicForm, Autocomplete
  },
  computed: {
    ...mapState(["endPoint", "profileId", "serverType"]),
  },
  mounted: async function() {
    // Meta-data Call
    const sytemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Company?field_name=name",
      null
    );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        sytemModuleId +
        "?field_name=system_module_id",
      null
    );
    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      if (accSystemModule != null) {
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }
        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
    }

    if (this.serverType == "branch" || this.$attrs.viewMode == true) {
      var form = document.getElementById("form-proper");
      var elements = form.elements;
      for (var i = 0, len = elements.length; i < len; ++i) {
        elements[i].disabled = true;
      }
    }
    component_x = this;
    if (component_x.profileId > 0) {
      var data = await HTTPRequest.getRequest(
        component_x.endPoint + "companies/" + component_x.profileId,
        null
      );
      if (data == undefined) {
        component_x.$router.go();
      } else {
        if (data["error"] == undefined) {
          var formatDate = data["acknowledgement_receipt_date_issue"] != null ? moment(data["acknowledgement_receipt_date_issue"]).format("MMMM D, YYYY") : '';
          component_x.inputInternalId = data["internal_id"];
          component_x.inputCode = data["code"];
          component_x.inputName = data["name"];
          component_x.inputAddress = data["address"];
          component_x.inputContactPerson = data["contact_person"];
          component_x.inputContactPosition = data["contact_position"];
          component_x.inputTelephone = data["telephone"];
          component_x.inputFax = data["fax"];
          component_x.inputRemark = data["remark"];
          component_x.inputTin = data["tin"];
          component_x.inputCreatedBy = data["created_by"];
          component_x.inputCreatedAt = data["created_at"];
          component_x.inputUpdatedBy = data["updated_by"];
          component_x.inputUpdatedAt = data["updated_at"];
          component_x.inputCasPermitNumber = data["cas_permit_number"];
          component_x.inputDateIssue = formatDate;
          component_x.inputSerialNumberRange = data["series_number_range"];

          if (data["supplier_id"]) {
            var supplierData = await HTTPRequest.getRequest(this.endPoint + "suppliers/" + data["supplier_id"], null);
            component_x.supplierName = supplierData.name;
          }

          if (data["b2b_customer_id"]) {
            var b2bCustomerData = await HTTPRequest.getRequest(this.endPoint + "b2b_customers/" + data["b2b_customer_id"], null);
            component_x.b2bCustomerName = decrypt(b2bCustomerData.name);
          }

          if (data["whs_online_site_id"]) {
            var whsSiteData = await HTTPRequest.getRequest(this.endPoint + "sites/" + data["whs_online_site_id"], null);
            component_x.whsSiteName = whsSiteData.name;
          }

          if (data["whs_offline_site_id"]) {
            var whsSiteData = await HTTPRequest.getRequest(this.endPoint + "sites/" + data["whs_offline_site_id"], null);
            component_x.whsOfflineSiteName = whsSiteData.name;
          }

          component_x.selectedSupplier = data["supplier_id"];
          component_x.selectedB2bCustomer = data["b2b_customer_id"];
          component_x.selectedWhsSite = data["whs_online_site_id"];
          component_x.selectedOfflineWhsSite = data["whs_offline_site_id"];

        } else {
          this.errors = data["error"].split(","); //format will change when error message has comma
          //component_x.$router.push("/")
        }
      }
    }
    this.dynamicFormKey++;
  },
  data: function() {
    return {
      supplierOptions: [],
      b2bCustomerOptions: [],
      selectedSupplier: '',
      selectedB2bCustomer: '',
      b2bCustomerName: '',
      supplierName: '',
      selectedWhsSite: '',
      selectedOfflineWhsSite: '',
      whsSiteName: '',
      whsOfflineSiteName: '',
      authHeaders: {
        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
        "Access-Control-Allow-Origin": "*",
        'Request-Source': "BXI-Web",
        'ip': secureStorage.getItem("ipAddress")
      },
      inputCasPermitNumber: '',
      inputDateIssue: '',
      inputSerialNumberRange: '',
      inputCode: "",
      inputName: "",
      inputInternalId: "",
      inputAddress: "",
      inputContactPerson: "",
      inputContactPosition: "",
      inputTelephone: "",
      inputFax: "",
      inputRemark: "",
      inputTin: "",
      inputCreatedBy: "",
      inputCreatedAt: "",
      inputUpdatedBy: "",
      inputUpdatedAt: "",
      showDetails: true,
      errors: [],
      // FOR META-DATA
      customFormMode: 1,
      customForm: {},
      profileData: {},
      dynamicFormKey: 0,
      company: {},
      formErrors: [],
    };
  },
  filters: {
    dateFilter: function(timestamp) {
      return moment(timestamp).format("L LTS");
    },
  },
  methods: {
    b2bCustomerEndpoint(input) {
      return this.endPoint + '/b2b_customers?name=' + input;
    },
    supplierEndpoint(input) {
      return this.endPoint + '/suppliers?name=' + input;
    },
    whsSiteEndpoint(input) {
      return this.endPoint + `/sites?name=${input}&whs=warehouse`;
    },
    getB2bCustomer(b2bCustomer) {
      this.b2bCustomerName = decrypt(b2bCustomer.display);
      this.selectedB2bCustomer = decrypt(b2bCustomer.value);
    },
    getWhsSite(whsSite) {
      this.whsSiteName = whsSite.display;
      this.selectedWhsSite = whsSite.value;
    },
    getWhsOfflineSite(whsSite) {
      this.whsOfflineSiteName = whsSite.display;
      this.selectedOfflineWhsSite = whsSite.value;
    },
    getSupplier(supplier) {
      this.supplierName = supplier.display;
      this.selectedSupplier = supplier.value;
    },
    formattedDisplay(result) {
      return result.name;
    },
    updateSettings(newFormSettings, settingsGrouping, errors) {
      var formSettingsCopy = this.company;
      var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
      this.formErrors = errors;

      if (this.customFormMode == 3) {
        this.errors = errors;
      }

      this.company = mergedHash;
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    openDetails() {
      this.showDetails = true;
    },
    openHistory() {
      this.showDetails = false;
    },
    validateForm() {
      this.errors = [];
      this.errors.push(ValidateField.required('Company Code', this.inputCode));
      // this.errors.push(ValidateField.alphanumericWithSpecialChars('Company Code', this.inputCode));
      this.errors.push(ValidateField.required("Name", this.inputName));
      // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
      this.errors.push(ValidateField.required("Address", this.inputAddress));
      this.errors.push(
        ValidateField.alphanumericWithSpecialChars("Address", this.inputAddress)
      );
      this.errors.push(
        ValidateField.phoneNumberFormat("Telephone", this.inputTelephone)
      );
      this.errors.push(ValidateField.phoneNumberFormat("Fax", this.inputFax));
      this.errors.push(
        ValidateField.alphabetWithSpace(
          "Contact Person",
          this.inputContactPerson
        )
      );
      this.errors.push(
        ValidateField.alphanumericWithSpecialChars(
          "Position",
          this.inputContactPosition
        )
      );
      this.errors.push(ValidateField.required("TIN Number", this.inputTin));
      this.errors.push(
        ValidateField.alphanumericWithSpecialChars("TIN Number", this.inputTin)
      );
      this.errors.push(ValidateField.required("CAS Permit Number", this.inputCasPermitNumber));
      this.errors = this._.compact(this.errors);
      document.getElementsByClassName(
        "ant-drawer-wrapper-body"
      )[0].scrollTop = 0;
      return this.errors.length;
    },
    create: async function() {
      if (!this.validateForm()) {
        var companyPayload = {
          company: {
            name: this.inputName.trim(),
            code: this.inputCode.trim(),
            address: this.inputAddress,
            contact_person: this.inputContactPerson,
            contact_position: this.inputContactPosition,
            telephone: this.inputTelephone,
            fax: this.inputFax,
            remark: this.inputRemark,
            tin: this.inputTin,
            supplier_id: this.selectedSupplier,
            b2b_customer_id: this.selectedB2bCustomer,
            cas_permit_number: this.inputCasPermitNumber,
            whs_online_site_id: this.selectedWhsSite,
            whs_offline_site_id: this.selectedOfflineWhsSite,
            acknowledgement_receipt_date_issue: moment(this.inputDateIssue, "MMMM D, YYYY").format("YYYY-MM-DD"),
            series_number_range: this.inputSerialNumberRange
          },
        };
        var post_request = await HTTPRequest.postRequest(
          this.endPoint + "companies",
          null,
          companyPayload
        );
        if (post_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (post_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = post_request["error"].split(","); //format will change when error message has comma
            //this.$router.push("/")
          }
        }
      }
    },
    update: async function() {
      if (!this.validateForm()) {
        var companyPayload = {
          company: {
            name: this.inputName.trim(),
            code: this.inputCode.trim(),
            address: this.inputAddress,
            contact_person: this.inputContactPerson,
            contact_position: this.inputContactPosition,
            telephone: this.inputTelephone,
            fax: this.inputFax,
            remark: this.inputRemark,
            tin: this.inputTin,
            internal_id: this.inputInternalId,
            supplier_id: this.selectedSupplier,
            b2b_customer_id: this.selectedB2bCustomer,
            cas_permit_number: this.inputCasPermitNumber,
            whs_online_site_id: this.selectedWhsSite,
            whs_offline_site_id: this.selectedOfflineWhsSite,
            acknowledgement_receipt_date_issue: moment(this.inputDateIssue, "MMMM D, YYYY").format("YYYY-MM-DD"),
            series_number_range: this.inputSerialNumberRange
          },
        };
        var put_request = await HTTPRequest.putRequest(
          this.endPoint + "companies/" + this.profileId,
          null,
          companyPayload
        );
        if (put_request == undefined) {
          this.$emit("refreshPage", event);
        } else {
          if (put_request["error"] == undefined) {
            this.$emit("refreshPage", event);
          } else {
            this.errors = put_request["error"].split(","); //format will change when error message has comma
            //this.$router.push("/")
          }
        }
      }
    },
  },
};
</script>

<style></style>